import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityLocationFreeShipApi } from 'api';
import { entityLocationFreeShipQuery } from 'containers/Branding/Farm/Setting/commons/query';

export const createMultiEntityLocationFreeShip = createAsyncThunk(
  'entityLocationFreeShip/createMultiEntityLocationFreeShip',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLocationFreeShipApi.createMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityLocationFreeShip = createAsyncThunk(
  'entityLocationFreeShip/findEntityLocationFreeShip',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityLocationFreeShipApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}

export const removeMultiEntityLocationFreeShip = createAsyncThunk(
  'entityLocationFreeShip/removeMultiEntityLocationFreeShip',
  async (ids: string[], { rejectWithValue }) => {
    try {
      const response = await EntityLocationFreeShipApi.removeMulti(ids);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeAllEntityLocationFreeShipByOwnerID = createAsyncThunk(
  'entityLocationFreeShip/removeAllEntityLocationFreeShipByOwnerID',
  async (_, { rejectWithValue }) => {
    try {
      const response = await EntityLocationFreeShipApi.removeAllByOwnerID();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  data: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  data: [],
  reloadFlag: false,
  query: entityLocationFreeShipQuery,
};

const entityLocationFreeShipSlice = createSlice({
  name: 'entityLocationFreeShip',
  initialState,
  reducers: {
    reloadEntityLocationFreeShip(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityLocationFreeShip.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = data;
    });
    builder.addCase(
      createMultiEntityLocationFreeShip.fulfilled,
      (state, action) => {
        state.data = state.data.concat(action.payload);
      }
    );
    builder.addCase(
      removeMultiEntityLocationFreeShip.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        const removedIds: string[] = data.map(item => item.id);
        state.data = state.data.filter(item => !removedIds.includes(item.id));
      }
    );
    builder.addCase(
      removeAllEntityLocationFreeShipByOwnerID.fulfilled,
      (state, action) => {
        state.data = [];
      }
    );
  },
});

const { actions, reducer: entityEntityLocationFreeShipReducer } =
  entityLocationFreeShipSlice;

export const { reloadEntityLocationFreeShip } = actions;

export default entityEntityLocationFreeShipReducer;
